import { UTC }                                   from 'rewire-common';
import DataMutations                             from '../graphql/Mutations';
import ArchiveDeleteDialogModel                  from './ArchiveDeleteDialogModel';
import { ArchiveDeleteGroupConfirmationContent } from './ArchiveDeleteGroupDialog';

export class ArchiveDeleteGroupDialogModel extends ArchiveDeleteDialogModel {
  constructor() {
    super('groups');
  }

  async _delete(id: string, endDate: UTC): Promise<boolean> {
    return !!(await DataMutations.deleteGroups([id], endDate));
  }

  _getConfirmationContentComponent() {
    return ArchiveDeleteGroupConfirmationContent;
  }
}

const archiveDeleteGroupDialogModel = new ArchiveDeleteGroupDialogModel();
export default archiveDeleteGroupDialogModel;